// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataStream } from './DataStream';
export class SocketDataStream extends DataStream {
    constructor(ws, delegates) {
        super(delegates.OnMessageDelegate);
        this.StreamOpened = false;
        const waitTimoutInSecounds = 30000;
        const timeout = setTimeout(() => {
            if (ws.readyState === WebSocket.CONNECTING) {
                console.error(`WebSocket connection ${ws.url} is still in CONNECTING state after ${waitTimoutInSecounds} ms. This may indicate a TLS/proxy/upgrade/firewall issue.`);
                ws.close(4001, 'connect timeout');
            }
        }, waitTimoutInSecounds);
        this.ws = ws;
        this.OnOpenDelegate = delegates.OnOpenDelegate;
        this.OnCloseDelegate = delegates.OnCloseDelegate;
        this.OnErrorDelegate = delegates.OnErrorDelegate;
        const prevOnOpen = this.onopen.bind(this);
        const prevOnError = this.onerror.bind(this);
        const prevOnClose = this.onclose.bind(this);
        let cleaned = false;
        const cleanup = () => {
            if (cleaned)
                return;
            cleaned = true;
            clearTimeout(timeout);
        };
        ws.onopen = (ev) => {
            cleanup();
            prevOnOpen(ev);
        };
        ws.onerror = (ev) => {
            cleanup();
            prevOnError(ev);
        };
        ws.onclose = (ev) => {
            cleanup();
            prevOnClose(ev);
        };
        ws.onmessage = this.onmessage.bind(this);
    }
    onmessage(evt) {
        if (this.OnMessageDelegate !== null) {
            this.OnMessageDelegate(evt.data);
        }
    }
    onopen() {
        this.StreamOpened = true;
        if (this.OnOpenDelegate) {
            this.OnOpenDelegate(true);
        }
    }
    onclose(evt) {
        if (evt.code !== 1000) {
            this.onerror(evt);
        }
        this.StreamOpened = false;
        if (this.OnCloseDelegate) {
            this.OnCloseDelegate();
        }
    }
    onerror(evt) {
        var _a;
        console.error(`[WebSocket error] Error during connection ${(_a = this.ws) === null || _a === void 0 ? void 0 : _a.url} ${evt === null || evt === void 0 ? void 0 : evt.message}`);
        if (this.OnErrorDelegate) {
            this.OnErrorDelegate(false);
        }
        this.Dispose();
    }
    Dispose() {
        if (!this.ws) {
            return;
        }
        this.StreamOpened = false;
        this.ws.onopen = null;
        this.ws.onclose = null;
        this.ws.onmessage = null;
        this.ws.onerror = null;
        this.OnOpenDelegate = null;
        this.OnCloseDelegate = null;
        this.OnErrorDelegate = null;
        this.ws.close();
        this.ws = null;
    }
    CloseStream() {
        if (!this.ws) {
            return;
        }
        this.StreamOpened = false;
        this.ws.onopen = null;
        this.ws.onclose = null;
        this.ws.onmessage = null;
        this.ws.onerror = null;
        this.OnOpenDelegate = null;
        this.OnCloseDelegate = null;
        this.OnErrorDelegate = null;
        this.ws.close();
        this.ws = null;
    }
    Connected() {
        return this.StreamOpened;
    }
    SendData(message) {
        if (this.Connected()) {
            this.ws.send(message);
        }
        // else
        //    this.Dispose();
    }
}
